<template>
  <div>
    <form action="/">
      <van-search
        v-model="valueName"
        placeholder="用户名/身份证号"
        show-action
        @search="onSearch"
        @cancel="onCancel"
      />
    </form>
    <ul class="scrollList">
      <li v-for="item of hoseList" v-bind:key="item.AchievementID">
        <div class="box-body">
          <h3>{{item.RecruitName}}</h3>
          <span class="sex-name">审核结果: {{item.RecruitStudentStateName}}</span>
          <span class="full-name">审核时间: {{item.ApproveDate}}</span>
        </div>
      </li>
    </ul>
    <!-- 数据全部加载完毕显示 -->
    <div style="text-align:center margin-top:15px;">
      <span v-if="hoseListLength">没有更多数据</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "showAchievement",
  components: {},
  data() {
    return {
      valueName: "",

      hoseListLength: false,
      hoseList: [] //table数据
    };
  },
  computed: {
    apipath() {
      return this.$store.state.apiPath;
    }
  },
  created() {
    //渲染table数据
    // var _data = {
    //   seachText: this.valueName
    // };
    this.getMod();
  },
  mounted() {},
  methods: {
    // 获取模块
    async getMod() {
      let res = await this.xyapi.get(
        `${this.apipath}/api/RecruitStudent/GetRecruitStudentByNC`,
        {
          seachText: this.valueName
        }
      );
      if (res.success) {
        var arr = res.data;
        if (arr !== null && arr.length > 0) {
          //this.hoseList = [...this.hoseList, ..._list];
        } else {
          this.hoseList = [];
          this.hoseListLength = true;
          // _this.$toast.fail('暂无模块可选');
        }
      } else {
        this.$toast.fail(res.msg);
      }
    },

    // 搜素
    onSearch() {
      this.getMod();
    },

    // 取消搜索
    onCancel() {
      this.valueName = "";
    },

    // 点击选择模块
    omModShow() {
      if (this.modColumns.length > 0) {
        this.modShow = true;
      } else {
        this.$toast.fail("暂无模块可选");
      }
    },

    // 确定模块
    onConfirmMod(value) {
      var _this = this;
      _this.modShow = false;
      _this.onConfirm(value, _this.modList);
    },

    // 选中
    onConfirm(value, list) {
      var item = "";
      for (var i = 0; i < list.length; i++) {
        if (value === list[i].AchievementName) {
          item = list[i];
        }
      }
      this.dataActiveItem = item;
      console.log(this.dataActiveItem);
    },

    // 查询
    search() {
      this.hoseList = [];
      if (this.dataActiveItem <= 0) {
        this.$toast.fail("请选择模块！");
        return;
      }
      if (this.seachText.length <= 0) {
        this.$toast.fail("请输入用户名/姓名！");
        return;
      }
      var _data = {
        achievementID: this.achievementID,
        seachText: this.seachText
      };

      this.getTP(_data);
    },

    async getTP(data) {
      let res = await this.xyapi.get(
        `${this.apipath}/api/Achievement/GetMobelAchievementScore/`,
        {
          seachText: data.seachText,
          achievementID: data.achievementID
        }
      );
      if (res.success) {
        this.hoseList = [];
        if (res.data !== null && res.data.length > 0) {
          this.hoseList = res.data;
          this.hoseListLength = false;
        } else {
          this.hoseListLength = true;
        }
      } else {
        this.$toast.fail(res.msg);
      }
    }
  }
};
</script>
<style lang="less" scoped>
</style>

